import React, { ClipboardEventHandler, InputHTMLAttributes, KeyboardEventHandler } from 'react';
import { Container } from '@fiverr-private/layout_components';
import {
    Input,
    FormLabel,
    FormHeader,
    FormElement,
    FormTooltip,
    FormControl,
    FormCounter,
    FormSubtitle,
    FormHelperText,
} from '@fiverr-private/forms';

interface FormInputProps {
    name: string;
    label?: string | React.ReactNode;
    placeholder: string;
    min?: number;
    max?: number;
    step?: number;
    tooltip?: string;
    subtitle?: string;
    disabled?: boolean;
    maxLength?: number;
    showCounter?: boolean;
    type?: InputHTMLAttributes<HTMLInputElement>['type'];
    onKeyDown?: KeyboardEventHandler;
    onPaste?: ClipboardEventHandler;
}

export const FormInput = ({
    name,
    label,
    placeholder,
    tooltip,
    subtitle,
    min,
    max,
    step,
    type = 'text',
    disabled = false,
    maxLength = 2500,
    showCounter = false,
    onKeyDown,
    onPaste,
}: FormInputProps) => (
    <Container flex="1">
        <FormControl maxLength={maxLength} name={name}>
            {(label || subtitle) && (
                <FormHeader>
                    {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
                    {tooltip && <FormTooltip content={tooltip} />}
                    {subtitle && <FormSubtitle>{subtitle}</FormSubtitle>}
                </FormHeader>
            )}
            <FormElement>
                <Input
                    type={type}
                    {...(type === 'number' && { min, max, step })}
                    id={name}
                    disabled={disabled}
                    placeholder={placeholder}
                    onKeyDown={onKeyDown}
                    onPaste={onPaste}
                />
            </FormElement>
            <FormHelperText />
            {showCounter && <FormCounter />}
        </FormControl>
    </Container>
);
